import { ACCOUNTING_BILL_STATUS_ALLOCATED, ACCOUNTING_BILL_STATUS_BATCHED, ACCOUNTING_BILL_STATUS_SYNCED } from "@/actuals/constants"
import { request } from "@/Api"
import { downloadFile, formattedCurrency } from "@/utils"
import { Button, CircularProgress, Grid, Modal, useTheme } from "@mui/material"
import { CustomBox, TargetsWarning } from "@/common/StyledComponents"
import { useSelector } from "react-redux"
import { closePopup, openPopup, selectPopupOpen, selectSelectedBills, unCheckAllBills } from "./accountingBillsSlice"
import { useDispatch } from "react-redux"
import { useState } from "react"
import { CheckedTotal } from "./AccountingBills"
import { setError } from "@/nav/navSlice"

export default function BatchActionConfirmationPopup({refresh}){
    const [waiting, setWaiting] = useState(false)
    const dispatch = useDispatch()
    const selectedBillsDict = useSelector(selectSelectedBills)
    const selectedBills = Object.values(selectedBillsDict)
    const selectedBillKeys = Object.keys(selectedBillsDict)
    const isOpen = useSelector(selectPopupOpen)
    const theme = useTheme()
    const hasBillsSelected = selectedBills.length > 0
    const firstBillStatus = selectedBills.length > 0 ? selectedBills[0].status : null
    const firstBillCurrency = selectedBills.length > 0 ? selectedBills[0].currency : null
    const canExport = hasBillsSelected
    const mode = (firstBillStatus == ACCOUNTING_BILL_STATUS_ALLOCATED || firstBillStatus == null) ? "Sync" : [ACCOUNTING_BILL_STATUS_SYNCED, ACCOUNTING_BILL_STATUS_BATCHED].includes(firstBillStatus) ? "Mark as Paid" : "Sync"
    const syncSelectedBills = () => {
        const requests = []
        selectedBills.forEach((bill) => {
            requests.push(request.post("accounting-bills/external", null, {params: {accounting_bill_id: bill.id}}))
        })
        return requests
    }
    const exportAchRbc = () => {
        const selectedBillIds = selectedBillKeys
        if (selectedBillIds.length > 0) {
            downloadFile(`accounting-bills/ach-rbc`, { ids: selectedBillIds }, () => setWaiting(false))
        }
    }
    const exportAch = (bank) => {
        const selectedBillIds = selectedBillKeys
        if (selectedBillIds.length > 0) {
            downloadFile(`accounting-bills/ach-${bank}`, { ids: selectedBillIds }, () => setWaiting(false))
        }
    }
    const markSelectedBillsAsPaid = () => {
        const requests = []
        selectedBills.forEach((bill) => {
            requests.push(request.patch(`accounting-bills/${bill.id}/mark-paid`))
        })
        return requests
    }
    const handlePopupConfirm = () => {
        let requests = []
        const toSyncBills = selectedBills.filter((bill) => bill.status == ACCOUNTING_BILL_STATUS_ALLOCATED || bill.status == null)
        const toMarkAsPaidBills = selectedBills.filter((bill) => [ACCOUNTING_BILL_STATUS_SYNCED, ACCOUNTING_BILL_STATUS_BATCHED].includes(bill.status))
        if (toSyncBills.length > 0) {
            requests = requests.concat(syncSelectedBills())
        }
        if (toMarkAsPaidBills.length > 0) {
            requests = requests.concat(markSelectedBillsAsPaid())
        }
        setWaiting(true)
        Promise.all(requests)
        .then((responses) => {
            responses.forEach((response) => {
                if (response.status == 200) {
                    dispatch(setError({message: "Bills processed successfully", severity: "success"}))
                }
            })
            refresh && refresh()
            dispatch(unCheckAllBills())
        })
        .catch((err) => {
            dispatch(setError({message: JSON.stringify(err.response ? err.response.data.detail : err), severity: "error"}))
        })
        .finally(() => {
            setWaiting(false)
            handleClose()
        })
    }
    const handleOpen = () => {
        dispatch(openPopup())
    }
    const handleClose = () => {
        dispatch(closePopup())
    }
    const handleExport = () => {
        if (firstBillCurrency == "USD") {
            exportAch("td")
        } else {
            exportAch("rbc")
        }
    }
    return (
        <>
            <Grid container spacing={2}>
                <Grid item>{hasBillsSelected && <Button variant="contained" onClick={handleOpen}>{mode}</Button>}</Grid>
                <Grid item>{canExport && <Button variant="contained" onClick={handleExport}>Export</Button>}</Grid>
            </Grid>
            <Modal open={isOpen} onClose={handleClose}>
                <CustomBox sx={{
                    paddingLeft: 4,
                    paddingRight: 4,
                    background: theme.palette.background.default,
                    overflow: "scroll",
                    width: "80%",
                }}>
                    <TargetsWarning>
                        {selectedBills.map((bill, index) =>
                            <Grid container key={index} justifyContent={"space-between"}>
                                <Grid item>
                                    <p>
                                        you are about to {
                                            <span style={{color: "#D7BB72", fontWeight: 800}}>{bill.status == ACCOUNTING_BILL_STATUS_ALLOCATED ? "sync" : bill.status == ACCOUNTING_BILL_STATUS_SYNCED ? "mark as paid" : "mark as paid"}</span>
                                        } the bill with invoice number {bill.accounting_bill_number || "n/a"} from vendor {bill.vendor_name}.
                                    </p>
                                </Grid>
                                <Grid item>
                                    <p key={index}>
                                        {formattedCurrency(bill.total, bill.currency)}
                                    </p>
                                </Grid>
                            </Grid>
                        )}
                        <div style={{textAlign: "right", paddingTop: 19}}>
                            <CheckedTotal />
                        </div>
                    </TargetsWarning>
                    <br/>
                    <div style={{textAlign: "right"}}>
                        { waiting ? <CircularProgress /> : <div style={{textAlign: "right"}}><Button variant="contained" onClick={handlePopupConfirm}>Confirm</Button></div>}
                    </div>
                </CustomBox>
            </Modal>
        </>
    )
}